import i18n from 'i18next'
import EmailObj from './EmailObj'
import dataManager from './DataManager'

const convertJMAPEmail = (list) => {
  if (list == null) {
    return null
  }
  return list.map((item) => {
    return { email: item.address, name: item.name }
  })
}

export class EMLEmail extends EmailObj {
  detail: any | null
  viewSubject: string
  originalData: any
  reqInfo: any

  constructor(dataMgr: any) {
    super(dataMgr)
    this.detail = null

    this.reqInfo = {
      waitingReq: [],
      isLoading: false,
    }
  }

  setEML = (postalMimeEML: any) => {
    this.originalData = postalMimeEML

    if (
      postalMimeEML.subject == null &&
      postalMimeEML.from == null &&
      postalMimeEML.html == null &&
      postalMimeEML.text == null
    ) {
      const error: any = new Error('postalMimeEML is invalid')
      error.type = 'invalidEML'
      throw error
    }

    const from =
      postalMimeEML.from != null
        ? [
            {
              email: postalMimeEML.from.address,
              name: postalMimeEML.from.name,
            },
          ]
        : null

    let hasAttachment = false
    if (postalMimeEML.attachments != null && postalMimeEML.attachments.length > 0) {
      hasAttachment = postalMimeEML.attachments.some((attachment) => {
        const { disposition } = attachment
        return disposition != null && disposition.toLowerCase() === 'attachment'
      })
    }

    this.data = {
      mailboxIds: {},
      id: postalMimeEML.messageId,
      subject: postalMimeEML.subject,
      messageId: [postalMimeEML.messageId],
      from,
      to: convertJMAPEmail(postalMimeEML.to),
      cc: convertJMAPEmail(postalMimeEML.cc),
      bcc: convertJMAPEmail(postalMimeEML.bcc),
      preview: postalMimeEML.snippet,
      receivedAt: postalMimeEML.date,
      hasAttachment,
      attachments: postalMimeEML.attachments,
    }
  }

  applyData = (/* data: any */) => {
    return false
  }

  isMovable = () => {
    return false
  }

  getViewSubject = (): string => {
    return this.data.subject
  }

  getViewTime = (): string => {
    let timeStr = this.data.receivedAt
    if (timeStr.endsWith('Z') === false) {
      timeStr += 'Z'
    }
    return timeStr
  }

  isFlagEnabled = (): boolean => {
    return false
  }

  hasAttachment = (): boolean => {
    return this.data.hasAttachment === true
  }

  getPreview = (): string => {
    if (this.data != null && this.data.preview != null && this.data.preview.trim().length > 0) {
      return this.data.preview
    }
    return i18n.t('email.desc.noPreview')
  }

  getDeleteType = (): string => {
    return 'destroy'
  }

  isContained = (mailbox: any): boolean => {
    return mailbox.isContain(this)
  }

  isDraft = (): boolean => {
    return false
  }
  setRead = (value: any, targetMailbox: any): any => {
    console.log('setRead', value, targetMailbox)
    return Promise.resolve(null)
  }
  isRead = (): boolean => {
    return true
  }
  isFlagged = (): boolean => {
    return false
  }
  reqDetail = (reload?: boolean): Promise<any> => {
    console.log('reqDetail', reload)
    if (this.detail != null) {
      return Promise.resolve(this.detail)
    }

    if (this.reqInfo.isLoading === false) {
      this.reqInfo.isLoading = true
      return (async () => {
        try {
          const bodyPart = await this.makeBodyPartFromEML(this.originalData)
          this.detail = {
            ...this.data,
          }
          this.detail.headers = this.originalData.headers.map((header) => {
            return {
              name: header.key,
              value: header.value,
            }
          })
          this.detail.bodyPart = bodyPart
          this.detail.hasAttachment = bodyPart.files != null && bodyPart.files.length > 0

          this.reqInfo.waitingReq.forEach((promise) => {
            promise.resolve(this.detail)
          })
          this.reqInfo.waitingReq = []
          this.reqInfo.isLoading = false
          return this.detail
        } catch (err) {
          this.reqInfo.waitingReq.forEach((promise) => {
            promise.reject(err)
          })
          this.reqInfo.waitingReq = []
          this.reqInfo.isLoading = false
          throw err
        }
      })()
    } else {
      const promise = new Promise((resolve, reject) => {
        this.reqInfo.waitingReq.push({ resolve, reject })
      })
      return promise
    }
  }
  loadSelf = (): Promise<any> => {
    return Promise.resolve(null)
  }
  generateQHeadStr = (): Promise<any> => {
    return Promise.resolve(null)
  }
  downloadEml = (): Promise<any> => {
    return Promise.resolve(null)
  }
  buildEML = () => {
    return Promise.resolve(null)
  }
  saveEML = () => {
    return Promise.resolve(null)
  }
  getPrimaryMessageId = (): string | null => {
    const headers: Array<{ name: string; value: string }> = this.detail?.headers ?? []
    const references = headers.find((h) => h.name.toLowerCase() === 'references')
    if (references != null) {
      const parts = references.value.trim().split(' ')
      return parts[0] ?? null
    }
    const messageId = headers.find((h) => h.name.toLowerCase() === 'message-id')
    return messageId?.value ?? null
  }

  // OMD-151: EML 뷰어는 자기발신 inbox/sent 쌍에 속하지 않으므로 불명(null) 처리.
  isSentMail = (): boolean | null => {
    return null
  }

  getMessageId = (): string | null => {
    const messageId = this.data.messageId
    if (messageId == null) {
      return null
    }
    return messageId[0] ?? null
  }
}

export const createEMLEmail = async (postalMimeEML: any) => {
  try {
    const email = new EMLEmail(dataManager)
    email.setEML(postalMimeEML)
    return email
  } catch (error) {
    console.log('createEMLEmail error : ', error)
    throw error
  }
}

const emlMap = {
  email: EMLEmail,
  mailbox: null,
  createEmail: createEMLEmail,
}

export default emlMap
